import styled from "styled-components";

export const BarraAzulContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding-left: 32px; */
  width: 100%;
  height: 110px;
  background-color: var(--color-latex10);
  z-index: 2;
  border-top: 2px solid var(--color-primary);
`;
export const BarraAzulBody = styled.div`
  color: var(--color-white);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  ${({ pacienteSeleccionado }) =>
    pacienteSeleccionado ? "padding-top: 30px;" : ""}
  .BarraAzul-paciente {
    font-size: 16px;
    font-weight: 400;
    z-index: 2;
  }
  .BarraAzul-paciente-bold {
    font-weight: bold;
  }
  .BarraAzul-subtitle {
    z-index: 2;
    font-size: 24px;
    font-weight: lighter;
  }
`;
export const BarraAzulCurva = styled.div`
  position: absolute;
  bottom: -18px;
  left: -130px;
  width: 120vw;
  height: 40px;
  background-color: var(--color-latex10);
  border-radius: 50%;
`;
export const BarraAzulBoton = styled.div`
  position: absolute;
  left: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 38px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--color-white);
  border: 2px solid var(--color-white);
  &::after {
    content: '';
    position: absolute;
    inset: -5px 0;
  }
`;
